export const topNavigation = [
  {
    text: 'About',
    link: '/business-first-then-technology',
    special: false,
    textOver: 'business first then technology'
  },
  {
    text: 'Contact',
    link: '/#lets-have-a-talk',
    special: false,
    textOver: 'contacts',
  },
]

export const contacts = [
{
  department: 'Support',
  phone: '+45 70203011',
  email: 'support@sitemule.com'
},
{
  department: 'Design',
  phone: '+45 70203011',
  email: 'design@sitemule.com'
},
{
  department: 'Corporate',
  address: 'System & Method 8,\nHaandvaerksvinget,\n2970 Zealand \nDenmark',
  phone: '+45 70203010',
  email: 'info@system-method.com'
},
];

export const content = [
  {
      text: 'Hero header',
      link: '/#hero',
  },
  {
      text: 'Integration',
      link: '/#integration',
  },
  {
      text: 'Transformation',
      link: '/#transformation',
  },
  {
      text: 'Innovation',
      link: '/#innovation',
  },
  {
      text: 'Our Relationships',
      link: '/#relations',
  },
  {
      text: 'Get Technical',
      link: '/#technical',
  },
  {
      text: 'Sitemule - team',
      link: '/#team',
  },
  {
      text: 'Lets talk',
      link: '/#lets-have-a-talk',
  },
  ];

export const softwares = [
  {
    icon: '../assets/images/pink-circle.svg',
    header: '/website',
    description:
      'Everything you need to maintain a modern appealing website. Serves users super fast and scores high on Google Speed Insights.',
  },
  {
    icon: '../assets/images/pink-circle.svg',
    header: '/webshop',
    description:
      'Wether you are B+B or want to aim directly at end users you get features included not included in any other solution.',
  },
  {
    icon: '../assets/images/pink-circle.svg',
    header: '/cms',
    description:
      'Easy to use and dedicated to create and publishing superior content… fast. You will never run out of options or power.',
  },
  {
    icon: '../assets/images/pink-circle.svg',
    header: '/pim',
    description:
      'Handling more than 1.000.000 products in a single installation with ease while still running fast and furious serving users.',
  },
];

export const development = [
  {
    icon: '../assets/images/yellow-circle.svg',
    header: '/menu-system',
    description:
      'User, roles and application management that can manipulated in infinity. Still this is the most reliable system around.',
  },
  {
    icon: '../assets/images/yellow-circle.svg',
    header: '/erp',
    description:
      'Dipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqu, quis nostrud exercitation.',
  },
  {
    icon: '../assets/images/yellow-circle.svg',
    header: '/pim',
    description:
      'A PIM solution line no other'
  },
];

export const server = [
  {
    icon: '../assets/images/yellow-circle.svg',
    header: '/instant-db2-access',
    description:
      'Dipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqu, quis nostrud exercitation.',
  },
  {
    icon: '../assets/images/yellow-circle.svg',
    header: '/data-model-designer',
    description:
      'Dipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqu, quis nostrud exercitation.',
  },
  {
    icon: '../assets/images/yellow-circle.svg',
    header: '/rest-service-interface',
    description:
      'Dipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqu, quis nostrud exercitation.',
  },
  {
    icon: '../assets/images/yellow-circle.svg',
    header: '/rpg-dev-environment',
    description:
      'Dipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqu, quis nostrud exercitation.',
  },
  {
    icon: '../assets/images/yellow-circle.svg',
    header: '/server-management',
    description:
      'Dipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqu, quis nostrud exercitation.',
  },
  {
    icon: '../assets/images/yellow-circle.svg',
    header: '/5250',
    description:
      'Dipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqu, quis nostrud exercitation.',
  },
];

export const technicalLinks = [
  {
    label: 'PDF',
    href: '/persons-contact',
    backgroundColor: 'white',
    color: '#177AF4',
    size:'lg' as 'lg',
    textSize:'lg' as 'lg',
    mobileTabletSize:'md' as 'md',
    mobileTextSize:'md' as 'md',
    borderRadius:'40px',
    icon:'github-icon',
  },
  {
    label: 'Audio Book',
    href: '/persons-contact',
    backgroundColor: 'white',
    color: '#177AF4',
    size:'lg' as 'lg',
    textSize:'lg' as 'lg',
    mobileTabletSize:'md' as 'md',
    mobileTextSize:'md' as 'md',
    borderRadius:'40px',
    icon:'data_object',
  },
];

export const webBasedServiceLinks = [
  {
    label: 'Solutions',
    href: '/',
    backgroundColor: 'white',
    color: '#white',
    size:'lg' as 'lg',
    textSize:'lg' as 'lg',
    mobileTabletSize:'md' as 'md',
    mobileTextSize:'md' as 'md',
    borderRadius:'28px',
  },
];

export const clients = [
  {
    logo: '../../../assets/logos/co-ownership.png',
    name: 'coownership',
    description: 'The biggest innovative B+B laundry service contractor with branches all over the nordic countries. About the work1:',
  },
  {
    logo: '../../../assets/logos/dfd.png',
    name: 'coownership',
    description: 'The biggest innovative B+B laundry service contractor with branches all over the nordic countries. About the work2',
  },
  {
    logo: '../../../assets/logos/dancenter.png',
    name: 'datacenter',
    description: 'The biggest innovative B+B laundry service contractor with branches all over the nordic countries. About the work3',
  },
  {
    logo: '../../../assets/logos/folkelarsen.png',
    name: 'folkelarsen',
    description: 'The biggest innovative B+B laundry service contractor with branches all over the nordic countries. About the work4',
  },
  {
    logo: '../../../assets/logos/ford.png',
    name: 'ford',
    description: 'The biggest innovative B+B laundry service contractor with branches all over the nordic countries. About the work5',
  },
  {
    logo: '../../../assets/logos/ftz.png',
    name: 'ftz',
    description: 'The biggest innovative B+B laundry service contractor with branches all over the nordic countries. About the work6',
  },
  {
    logo: '../../../assets/logos/htbendix.png',
    name: 'htb',
    description: 'The biggest innovative B+B laundry service contractor with branches all over the nordic countries. About the work7',
  },
  {
    logo: '../../../assets/logos/letstalk.png',
    name: 'letstalk',
    description: 'The biggest innovative B+B laundry service contractor with branches all over the nordic countries. About the work8',
  },
  {
    logo: '../../../assets/logos/logitrans.png',
    name: 'Logitrans',
    description: 'The biggest innovative B+B laundry service contractor with branches all over the nordic countries. About the work9',
  },
  {
    logo: '../../../assets/logos/nissan.png',
    name: 'nissan',
    description: 'The biggest innovative B+B laundry service contractor with branches all over the nordic countries. About the work10',
  },
  {
    logo: '../../../assets/logos/politi.png',
    name: 'politi',
    description: 'The biggest innovative B+B laundry service contractor with branches all over the nordic countries. About the work11',
  },
  {
    logo: '../../../assets/logos/xy.png',
    name: 'xy',
    description: 'About the work12',
  },
];

export const allPersons = [
  {
    name: 'Martin Hecht Olsen',
    position: 'CEO',
    image: '../../../../assets/sitemule-members/martin-hecht-olsen.jpg',
    phone: '+45 40 11 77 11',
    email: 'mho@sitemule.com',
  },
  {
    name: 'Niels Liisberg',
    position: 'Chief Innovation Officer',
    image: '../../../../assets/sitemule-members/niels-liisberg.jpg',
    phone: '+45 31 15 88 61',
    email: 'nli@sitemule.com',
  },
  {
    name: 'Jens Churchill',
    position: 'CTO',
    image: '../../../../assets/sitemule-members/jens-churchill.jpg',
    phone: '+45 30 44 80 04',
    email: 'jmc@sitemule.com',
  },
  {
    name: 'Sandesh Shrestha',
    position: 'Principal, Frontend',
    image: '../../../../assets/sitemule-members/sandesh-shrestha.jpg',
    phone: '+45 27 50 64 78',
    email: 'san@sitemule.com',
  },
  {
    name: 'Kenneth Riber Andersen',
    position: 'Principal, UX UI',
    image: '../../../../assets/sitemule-members/kenneth-riber-andersen.jpg',
    phone: '+45 61 47 26 26',
    email: 'kra@sitemule.com',
  },
  {
    name: 'Grith Skovboelle',
    position: 'Support Lead',
    image: '../../../../assets/sitemule-members/grith-skovboelle.jpg',
    phone: '+45 51 27 44 43',
    email: 'gsk@sitemule.com',
  },
  {
    name: 'Bent Witte Rasmussen',
    position: 'Developer',
    image: '../../../assets/sitemule-members/bent.jpg',
    phone: '+45 20 87 55 26',
    email: 'bwr@sitemule.com',
  },
  {
    name: 'Claus Tümmler',
    position: 'Developer',
    image: '../../../assets/sitemule-members/default-image.png',
    phone: '+45 25 23 22 40',
    email: 'ctu@sitemule.com',
  },
  {
    name: 'Glenn Jarzomkowski',
    position: 'Developer',
    image: '../../../assets/sitemule-members/glenn.jpg',
    phone: '+45 26 73 45 99',
    email: 'gja@sitemule.com',
  },
  {
    name: 'Jeppe K. Bundgaard',
    position: 'Developer',
    image: '../../../assets/sitemule-members/default-image.png',
    phone: '+45 50 70 35 77',
    email: 'jkb@sitemule.com',
  },
  {
    name: 'Jørn Holm',
    position: 'Developer',
    image: '../../../assets/sitemule-members/default-image.png',
    phone: '+45 31 55 04 10',
    email: 'jho@sitemule.com',
  },
  {
    name: 'Claus Rytter Larsen',
    position: 'Developer',
    image: '../../../assets/sitemule-members/claus.jpg',
    phone: '+45 20 27 19 99',
    email: 'crl@sitemule.com',
  },
  {
    name: 'Peter Donabed Nøbbe',
    position: 'Developer',
    image: '../../../assets/sitemule-members/peter.jpg',
    phone: '+45 60 24 59 52',
    email: 'pno@sitemule.com',
  },
  {
    name: 'Emil Fridthjof',
    position: 'Developer',
    image: '../../../assets/sitemule-members/default-image.png',
    phone: '+45 28 73 90 34',
    email: 'erf@sitemule.com',
  },
  {
    name: 'Morten Pedersen',
    position: 'Developer',
    image: '../../../assets/sitemule-members/morten.jpg',
    phone: '+45 28 49 15 20',
    email: 'mop@sitemule.com',
  },
  {
    name: 'Bhuwan Poudel',
    position: 'Developer',
    image: '../../../assets/sitemule-members/default-image.png',
    phone: '+45 81 91 68 93',
    email: 'bks@sitemule.com',
  },
  {
    name: 'Anders Kristian Andersen',
    position: 'Developer',
    image: '../../../assets/sitemule-members/default-image.png',
    phone: '+45 22 16 63 77',
    email: 'aka@sitemule.com',
  },
  {
    name: 'Henning Ørnsø',
    position: 'Hosting Manager',
    image: '../../../assets/sitemule-members/henning.jpg',
    phone: '+45 40 88 87 24',
    email: 'hrn@sitemule.com',
  },
];
